module.exports = __webpack_public_path__ + "img/Jingren_Zhou.1d1071a0.jpg";